import { useCallback, useMemo, useState } from "react";
import { useFavoriteArticles } from "@louise/favorites";
import { getDevArticleBookmarkFixtureState } from "../dev/articleBookmarkFixture";

/**
 * Keeps article bookmark behavior in one place, including the deterministic
 * web fixture used by visual review routes when account data is unavailable.
 */
export function useArticleBookmark(articleId: string) {
  const { isFavorite, toggleFavorite } = useFavoriteArticles();
  const fixtureState = useMemo(() => getDevArticleBookmarkFixtureState(), []);
  const [devBookmarkState, setDevBookmarkState] = useState<boolean | null>(
    fixtureState,
  );
  const hasFixture = fixtureState !== null;
  const bookmarked = hasFixture
    ? devBookmarkState === true
    : isFavorite(articleId);

  const toggleBookmark = useCallback(() => {
    if (hasFixture) {
      setDevBookmarkState((current) => !(current ?? false));
      return;
    }
    toggleFavorite(articleId);
  }, [articleId, hasFixture, toggleFavorite]);

  return { bookmarked, toggleBookmark, isFixture: hasFixture };
}
